import { render, staticRenderFns } from "./ChannelDialog.vue?vue&type=template&id=0a9cfb8e&scoped=true"
import script from "./ChannelDialog.vue?vue&type=script&lang=js"
export * from "./ChannelDialog.vue?vue&type=script&lang=js"
import style0 from "./ChannelDialog.vue?vue&type=style&index=0&id=0a9cfb8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9cfb8e",
  null
  
)

export default component.exports